var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "newscard" },
    [
      _c(
        "v-card",
        {
          staticClass:
            "mx-auto newsCard myBoxShadow myBorderRadius-important maxh",
        },
        [
          _c("div", { staticClass: "d-flex justify-center" }, [
            _vm.news.image
              ? _c("img", {
                  staticClass: "newsCardImage",
                  class: { bigger: _vm.showAll },
                  attrs: { src: _vm.news.image },
                })
              : _vm._e(),
          ]),
          _c(
            "v-list-item",
            [
              _c(
                "v-list-item-content",
                [
                  _c("div", { staticClass: "spacer-10" }),
                  _vm.showAll
                    ? _c("h1", { staticClass: "text-none" }, [
                        _vm._v(_vm._s(_vm.news.title)),
                      ])
                    : _c("h3", { staticClass: "text-none" }, [
                        _vm._v(_vm._s(_vm.news.title)),
                      ]),
                  _c("v-list-item-subtitle", [
                    _vm._v("Nachricht vom " + _vm._s(_vm.displayDate)),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-card-text", { staticStyle: { "padding-bottom": "65px" } }, [
            _vm.showAll
              ? _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.news.additionalText) },
                })
              : _c("div", { staticClass: "someLiner" }, [
                  _vm._v(" " + _vm._s(_vm.stripedHtml) + " "),
                ]),
          ]),
          _c(
            "v-card-actions",
            [
              _c(
                "v-list-item",
                { staticClass: "grow" },
                [
                  _c(
                    "v-row",
                    { staticClass: "bigger-input", attrs: { align: "center" } },
                    [
                      !_vm.showAll
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "text-none okBtn rounded100",
                              attrs: { rounded: "" },
                              nativeOn: {
                                "&click": function ($event) {
                                  $event.stopPropagation()
                                  return _vm.gotoBeitrag(_vm.news)
                                },
                              },
                            },
                            [_vm._v("Mehr lesen ")]
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "flex-grow-1" }),
                      _c(
                        "v-btn",
                        {
                          staticClass: "rounded100",
                          attrs: { icon: "" },
                          nativeOn: {
                            "&click": function ($event) {
                              $event.stopPropagation()
                              return _vm.share.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { medium: "" } }, [
                            _vm._v("mdi-share-variant"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showAll
        ? _c(
            "div",
            { staticClass: "pt-7 text-center" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "text-none btn-df",
                  attrs: { rounded: "" },
                  nativeOn: {
                    "&click": function ($event) {
                      return _vm.$ebus.$emit("goBack")
                    },
                  },
                },
                [_vm._v(" Weitere Nachrichten ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }